import { makeStyles } from '@forgeglobal/design-framework';

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    paddingLeft: '32px',
    paddingRight: '32px',
    paddingTop: '32px',
  },
  dialogActions: {
    justifyContent: 'flex-end',
    padding: '24px',
  },
}));

export default useStyles;
